import HomiQLogoMark from 'assets/homiq/logoContrast.svg?react';
import envConfig from 'configs/envConfig';
import { TPartnerAssets } from 'partners/types';
import { storedLocale } from 'partners/storedLocale';

const homiqBaseUrl = `${envConfig('b2BucketUrl')}/homeSecurity/homiq`;

export const defaultAssets: TPartnerAssets = {
  logo: `${homiqBaseUrl}/logo.svg`,
  loginIllustration: `${homiqBaseUrl}/loginIllustration.svg`,
  Days30EventIcon: `${homiqBaseUrl}/30DaysEventIcon.png`,
  attentionIcon: `${homiqBaseUrl}/attention.svg`,
  basicAlertsIcon: `${homiqBaseUrl}/basicAlertsIcon.svg`,
  basicMotionAlertsImg: `${homiqBaseUrl}/basicMotionAlerts.png`,
  clockIcon: `${homiqBaseUrl}/clockIcon.svg`,
  logoMarkIcon: HomiQLogoMark,
  // same as IV
  CannotAddSelectedCameraIcon: `${homiqBaseUrl}/CannotAddSelectedCamera.png`,
  decriptiveAIAlertsIcon: `${homiqBaseUrl}/decriptiveAIAlertsIcon.png`,
  // end
  firmwareVersionIcon: `${homiqBaseUrl}/firmwareVersionIcon.svg`,
  interntNotConnectedIcon: `${homiqBaseUrl}/interntNotConnected.svg`,
  limitedSecurityIcon: `${homiqBaseUrl}/limitedSecurityIcon.svg`,
  locationIcon: `${homiqBaseUrl}/location.svg`,
  logoContrastIcon: `${homiqBaseUrl}/logoContrast.svg`,
  logoWhiteIcon: `${homiqBaseUrl}/logoWhite.svg`,
  maxCameraLimitReachedIcon: `${homiqBaseUrl}/maxCameraLimitReached.svg`,
  AllCamerasAddedToAccountIcon: `${homiqBaseUrl}/AllCamerasAddedToAccount.svg`,
  noEventVideosIcon: `${homiqBaseUrl}/noEventVideosIcon.svg`,
  paymentFailedIcon: `${homiqBaseUrl}/paymentFailedIcon.svg`,
  DownGradeConfirmationIcon: `${homiqBaseUrl}/DownGradeConfirmation.svg`,
  paymentSuccessfulIcon: `${homiqBaseUrl}/PaymentSuccessful.svg`,
  planLevelOneIcon: `${homiqBaseUrl}/planLevelOneIcon.svg`,
  planLevelThreeIcon: `${homiqBaseUrl}/planLevelThreeIcon.svg`,
  planLevelTwoIcon: `${homiqBaseUrl}/planLevelTwoIcon.svg`,
  professionMonitoringIcon: `${homiqBaseUrl}/professionMonitoringIcons.svg`,
  sampleCreditCardIcon: `${homiqBaseUrl}/sampleCreditCard.svg`,
  FreeTrialActivatedIcon: `${homiqBaseUrl}/FreeTrialActivated.svg`,
  upgradeSnapshotIcon: `${homiqBaseUrl}/upgradeSnapshot.svg`,
  wifiIcon: `${homiqBaseUrl}/wifiIcon.svg`,
  appQRCodeAndroid: `${homiqBaseUrl}/qrCodeAndroid.png`,
  appQRCodeIos: `${homiqBaseUrl}/qrCodeIos.png`,
  motionAlertsIcon: `${homiqBaseUrl}/motionAlerts.png`,
  snapshotIcon: `${homiqBaseUrl}/snapshotIcon.png`,
  liveViewIcon: `${homiqBaseUrl}/liveViewIcon.png`,
  dataIcon: `${homiqBaseUrl}/dataIcon.png`,
  noDataIcon: `${homiqBaseUrl}/noDataIcon.png`,
  autoDataRechargeDisabled: `${homiqBaseUrl}/autoDataRechargeDisabled.png`
};

// 2️⃣ Locale-specific overrides
const localeOverrides: Record<string, Partial<TPartnerAssets>> = {
  es: {
    basicMotionAlertsImg: `${homiqBaseUrl}/basicMotionAlerts-es.png`
  }
};

// 3️⃣ Merge default with overrides
export const getAssetsForLocale = (locale: string): TPartnerAssets => {
  return {
    ...defaultAssets,
    ...localeOverrides[locale]
  };
};

const locale = storedLocale();

export const assets = getAssetsForLocale(locale || 'en-US');
